import hmd_softlock_logo from 'url:/assets/hmd_softlock_logo.svg'
import React from 'react'
import { INPUT_FORM_COMMON_SIZE } from '../../genericComponents/OverlayWrapper'
import { FlexContainer } from '../../genericComponents/layout/FlexContainer'
import { AuthPageContainer } from '../../genericComponents/layout/AuthPageContainer'

export const TokenExpiredPage: React.FC = () => {
  return (
    <AuthPageContainer>
      <FlexContainer
        align="items-center"
        gap="gap-0"
        justify="justify-center"
        className={'flex-col ' + INPUT_FORM_COMMON_SIZE}
      >
        <img src={hmd_softlock_logo} alt="" className="mb-6 w-40" />
        <h2 className="text-base font-semibold text-alertColor self-center my-5">
          The link you followed has expired.
        </h2>
        <p className="self-center">
          The URL is not valid anymore. Please use the <a href="/forgot_pw">Forgot password</a> to
          request a new link with your email address.
        </p>
      </FlexContainer>
    </AuthPageContainer>
  )
}
